<template>
<div style="display: flex; width: 100%; height: 100%;">

	<div v-if="view == 'DECKS'" style="display: flex; flex-direction: column; width: 100%; height: 100%; overflow-y: auto; padding: 80px 20px 20px 20px;">

		<div class="header">
			<div style="flex: 1 1 auto;">MyL Sandbox</div>
			<button class="btn-round" style="margin-right: 5px" @click="GoToCreateArenaDeck()">Mazo Arena</button>
			<button class="btn-round" style="margin-right: 5px" @click="GoToCreateRandomDeck()">Mazo Random</button>
			<button class="btn-round" @click="GoToCreateDeck()">Nuevo Mazo</button>
		</div>

		<div class="card-list" v-for="(deck, i) in decks"  :key="i" style="display: flex; align-items: center">
			<div style="flex: 1 1 auto">{{deck.name}}</div>
			<button class="btn-round" @click.stop="EditDeck(deck)" style="margin-right: 5px">Editar</button>
			<button class="btn-round" @click.stop="DeleteDeck(deck.name)" style="margin-right: 5px">Eliminar</button>
			<button class="btn-round" @click.stop="StartGame(deck.cards)" style="margin-right: 5px">Jugar</button>
		</div>

	</div>

  <div v-if="view == 'DECK'" class="search-menu" style="min-width: 300px; overflow-y: auto">
	
	<button @click="view = 'DECKS'" class="btn-round">Volver</button>
	
	<b>Búsqueda</b>
    <cards-filter ref="filter"
    v-model="filteredCards"
    :cards="cards">
    </cards-filter>

	<b>Ordenar</b>
    <select v-model="orderBy">
      <option value="alfabetico">Alfabético</option>
      <option value="coste">Coste</option>
      <option value="tipo">Tipo de carta</option>
      <option value="fuerza">Fuerza</option>
      <option value="raza">Raza</option>
	  <option value="edicion">Edición</option>
	  <option value="frecuencia">Frecuencia</option>
    </select>

  </div>

  
  
  <div :class="`content`" v-if="view == 'DECK'">
	<p v-if="!orderedCards.length" style="font-size: 10px; color: #CCC; text-align: center">No hay cartas</p>
	<img v-for="(card, index) in orderedCards" class="card-selection"
    :key="index"
	:src="`http://mylassets.mattkingz.cl/previews/${card.code}.jpg`"
	width="70"
	height="100"
	@click="deck.length < 50 ? AddCard(card) : null" 
	@mouseenter="Preview(card)"
	@mouseleave="Preview(null)"/>
  </div>

<div v-if="view == 'RANDOM_DECK'" class="search-menu" style="flex: 1 1 auto; overflow-y: auto; position: relative; padding-top: 80px">
	
	<div class="header">
		<button @click="view = 'DECKS'" class="btn-round">Volver</button>
		<div style="flex: 1 1 auto; margin-left: 10px">Mazo Random</div>
		<button class="btn-round" @click="CopyRandomRules">Copiar Reglas</button>
		<button class="btn-round" style="margin-left: 5px" @click="LoadRandomRules">Cargar Reglas</button>
		<button class="btn-round" style="margin-left: 5px" @click="randomizerSets.push({quantity: 20, rules: ['']})">Agregar Set</button>
		<button class="btn-round" style="margin-left: 5px" @click="CreateRandomDeck()">Crear Mazo</button>
	</div>
	
	<div style="padding: 10px; border: 1px solid whitesmoke; margin-bottom: 10px; display: flex; flex-direction: column; gap: 2px"
	v-for="(set, i) in randomizerSets" :key="i">
		<div style="display: flex;">
			<input ref="randomQuantity" value="20" type="number" placeholder="Número de cartas" v-model="set.quantity">
			<div style="flex: 1 1 auto"></div>
			<button class="btn-round" v-if="randomizerSets.length > 1" style="margin-right: 5px" @click="randomizerSets.splice(i, 1)">Quitar Set {{i+1}}</button>
			<button class="btn-round" @click="set.rules.push('')">Agregar regla</button>
		</div>
		
		<div style="display: flex;" v-for="(rule, j) in set.rules" :key="j">
			<!--{{rule}}-->
			<cards-filter :ref="`filter-${i}-${j}`" class="row-filter" style="flex: 1 1 auto"
			:rule="rule"
			:cards="cards"
			:canTextSearch="false"
			@FilterChanged="set.rules[j] = $event;$forceUpdate()">
			</cards-filter>
			<button v-if="set.rules.length > 1" @click="set.rules.splice(j, 1)" class="btn-round" style="width: 50px">X</button>
		</div>
	</div>
	
  </div>

	<div v-if="view == 'ARENA_DECK'" class="search-menu" style="min-width: 400px; overflow-y: auto; position: relative; padding-top: 70px">
	
		<div class="header">
			<button @click="view = 'DECKS'" class="btn-round">Volver</button>
			<div style="margin-left: 10px; flex: 1 1 auto">Arena</div>
			<button @click="CopyArenaRules" class="btn-round">Copiar Reglas</button>
			<button @click="LoadArenaRules" class="btn-round" style="margin-left: 5px">Cargar Reglas</button>
			<button @click="arenaSets.push([''])" class="btn-round" style="margin-left: 5px">Agregar Set</button>
		</div>
		
		<div class="card-list" style="max-width: 500px; overflow-x: auto; display: flex; flex-direction: column; gap: 2px"
		v-for="(set, i) in arenaSets" :key="i">
			<div style="display: flex">
				<button v-if="arenaSets.length > 1" @click="arenaSets.splice(i, 1)" class="btn-round" style="margin-right: 5px">Quitar Set {{i+1}}</button>
				<button class="btn-round" @click="set.push('')">Agregar Regla</button>
			</div>
			<div v-for="(rule, j) in set" :key="j" style="display: flex">
				<button @click="set.splice(j, 1)" v-if="set.length > 1" class="btn-round" style="margin-right:5px">X</button>
				<cards-filter :ref="`arena-filter-${i}-${j}`" class="row-filter sm"
				:rule="rule"
				:cards="cards"
				:canTextSearch="false"
				hideResults
				@FilterChanged="arenaSets[i][j] = $event; $forceUpdate()">
				</cards-filter>
			</div>
		</div>

	</div>

  <div v-if="view == 'ARENA_DECK'" class="search-menu" style="flex: 1 1 auto; display: flex; justify-content: center; align-items: center">

		<div style="display: flex; gap: 10px; flex-wrap: wrap; justify-content: center;">
			<img v-for="(card, index) in arenaOptions" class="card-selection"
			:key="index"
			:src="`http://mylassets.mattkingz.cl/previews/${card.code}.jpg`"
			width="100"
			@click="deck.length < 50 ? AddCard(card) : null;NextArenaOption()" 
			@mouseenter="Preview(card)"
			@mouseleave="Preview(null)"/>
		</div>
	
  </div>

  <div v-if="view != 'DECKS'" class="search-menu" style="min-width: 350px; max-width: 350px; overflow-y: auto">

		<div style="display: flex">
			<input v-model="currentDeckNameEdit" type="text" style="flex: 1 1 auto">
			<button @click="SaveCurrentDeck()" class="btn-round" style="margin-left: 5px">Guardar</button>
		</div>

		<b>Mazo ({{deck.length}})</b>
	  	<card v-for="(card, index) in deck" class="mini" style="margin-bottom: 2px"
		:key="index"
		:card="card"
		:showHabilidad="false"
		:showImage="false"
		:showPreview="true"
		@click.native="deck.splice(index, 1)"
		@mouseenter.native="Preview(card)"
		@mouseleave.native="Preview(null)"
		>
		</card>
		
		<b>Distribución</b>
		<button class="btn-round" @click="showDeckStats=true" v-if="!showDeckStats">Mostrar Distribución</button>
		<button class="btn-round" @click="showDeckStats=false" v-if="showDeckStats">Ocultar Distribución</button>
		<div style="display: flex; flex-direction: column; margin-top: 10px" v-if="showDeckStats && deck.length">
			<div style="text-align: center; margin-bottom: -30px; font-size: 12px; color: #666; pointer-events: none">Tipos</div>
			<apexchart width="100%" type="bar" :options="style"  style="margin-left: -10px"
			:series="[{
				name: 'Cartas',
				data: deckStats.types
			}]"></apexchart>
			<div style="text-align: center; margin-bottom: -30px; font-size: 12px; color: #666">Coste</div>
			<apexchart width="100%" type="bar" :options="styleCost" style="margin-left: -10px"
			:series="[{
				name: 'Cartas',
				data: deckStats.cost
			}]"></apexchart>
			<div style="text-align: center; margin-bottom: -30px; font-size: 12px; color: #666">Fuerza</div>
			<apexchart width="100%" type="bar" :options="styleAttack" style="margin-left: -10px"
			:series="[{
				name: 'Cartas',
				data: deckStats.attack
			}]"></apexchart>
		</div>
		
		<b>Código</b>
		<textarea class="code" rows="4" v-model="code"></textarea>
		<div style="display: flex; gap: 5px">
			<button class="btn-round" style="flex: 1 1 auto" v-if="code" @click="CopyCode()">Copiar Código</button>
			<button class="btn-round" style="flex: 1 1 auto" v-if="code" @click="LoadCode()">Cargar Código</button>
		</div>
		
		

  </div>


	<img v-if="preview" :src="`http://mylassets.mattkingz.cl/${preview.code}.jpg`" style="position: absolute; width: 400px; right: 350px; pointer-events: none; border-radius: 1vw">

</div>
</template>

<script>
import Card from './Card.vue';
import CardsFilter from './CardsFilter';
export default {
  props: {
    
  },
  data() {
    return {
		dictCards: {},
		cards: [],
		filteredCards: [],
		orderBy: 'alfabetico',
		deck: [],
		randomizer: 0,
		quantity: null,
		modalRandom: false,
		showDeckStats: false,
		code: '',
		preview: null,
		view: 'DECKS',
		style: {
				chart: {
					toolbar: {
						show: false
					}
				},
				colors: ['#345ae5'],
				grid: {
					show: false
				},
				yaxis: {
					floating: true,
					show: false
				},
				xaxis: {
				labels: {
					rotate: -45,
					style: {
						fontSize: '8px'
					},
				},
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false
				},
				categories: ['Aliados', 'Talismanes', 'Armas', 'Tótems', 'Oros']
			}
		},
		styleCost: {
			chart: {
				toolbar: {
					show: false
				}
			},
			colors: ['#dee03f'],
			grid: {
				show: false
			},
			yaxis: {
				show: false
			},
			xaxis: {
				labels: {
					rotate: -45,
					style: {
						fontSize: '8px'
					},
				},
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false
				},
				categories: ['1 o menos', '2', '3', '4', '5 o más']
			}
		},
		styleAttack: {
			chart: {
				toolbar: {
					show: false
				}
			},
			colors: ['#cc4c43'],
			grid: {
				show: false
			},
			yaxis: {
				show: false
			},
			xaxis: {
				labels: {
					rotate: -45,
					style: {
						fontSize: '8px'
					},
				},
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false
				},
				categories: ['1 o menos', '2', '3', '4', '5 o más']
			}
		},
		decks: [],
		currentDeckName: null,
		currentDeckNameEdit: null,
		randomizerSets: [],
		arenaOptions: [],
		arenaSets: [
			['T:oro'],[''],[''],['']
		]
    }
  },
  mounted() {
    var json = require('../primerbloque.json');
	this.cards = json;

	this.cards.forEach(card => {
		this.dictCards[card.code] = card;
	});
	this.LoadDecks();
  },
  methods: {
	StartGame(deck) {
		let room = prompt("Ingrese un codigo de juego", "0001");
		if(!room) return alert("Invalido");
		console.log(room);
		this.$socket.client.io.opts.query = {room: room, deck: deck};
        this.$socket.client.connect();
	},
	LoadDecks() {
		this.decks = localStorage.decks ? JSON.parse(localStorage.decks) : [];
	},
	GoToCreateDeck(name, cards)
	{
		this.deck = [];
		let date = new Date();
		let deck = {
			name: name ? name :`Mazo ${date.toLocaleString()}`,
			cards: cards ? cards : ''
		};
		this.EditDeck(deck);
		//this.decks.push(deck);
		//localStorage.decks = JSON.stringify(this.decks);
	},
	EditDeck(deck)
	{
		this.currentDeckName = deck.name;
		this.currentDeckNameEdit = deck.name;
		this.LoadCode(deck.cards);
		this.view = 'DECK';
	},
	DeleteDeck(deckName)
	{
		if(confirm(`Eliminar mazo: ${deckName}?`))
		{
			for(let i = 0; i < this.decks.length; i++)
			{
				if(this.decks[i].name == deckName)
				{
					this.decks.splice(i, 1);
					console.log(i);
					localStorage.decks = JSON.stringify(this.decks);
					return;
				}
			}
		}
	},
	SaveCurrentDeck(){

		if(!this.currentDeckNameEdit.trim()) return alert('Nombre inválido');

		alert(`Mazo [${this.currentDeckNameEdit}] guardado!`);
		let deck = {
			name: this.currentDeckNameEdit,
			cards: this.deckCode
		}
		for(let i = 0; i < this.decks.length; i++)
		{
			if(this.decks[i].name == this.currentDeckName)
			{
				this.decks[i] = deck;
				localStorage.decks = JSON.stringify(this.decks);
				return;
			}
		}
		this.decks.push(deck);
		localStorage.decks = JSON.stringify(this.decks);
		
	},
	AddCard(card)
	  {
		  this.deck.push(card);
		  this.deck.sort((a, b) => {
            var A = a.nombre.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('¡', '').replace('¿', '');
            var B = b.nombre.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('¡', '').replace('¿', '');
            if(A < B) return -1;
            if(B < A) return 1;
            return 0;
		  });
		this.deck.sort((a, b) => {
			var A = a.tipo == 'Oro' ? -1 : a.coste;
			var B = b.tipo == 'Oro' ? -1 : b.coste;
			return A - B;
		});
	},
	GoToCreateRandomDeck(name, cards)
	{
		this.deck = [];
		this.randomizerSets = [
			{quantity: 3, rules: ['F:Real']},
			{quantity: 12, rules: ['F:Cortesano']},
			{quantity: 22, rules: ['F:Vasallo']},
			{quantity: 13, rules: ['T:oro,F:Sin Frecuencia']},
		];
		this.view = 'RANDOM_DECK';
		let date = new Date();
		let deck = {
			name: name ? name :`Mazo Random ${date.toLocaleString()}`,
			cards: cards ? cards : ''
		};
		this.currentDeckName = deck.name;
		this.currentDeckNameEdit = deck.name;
	},
	GoToCreateArenaDeck(name, cards)
	{
		this.arenaSets = [
			['T:oro'],[''],[''],['']
		]
		this.deck = [];
		this.view = 'ARENA_DECK';
		let date = new Date();
		let deck = {
			name: name ? name :`Mazo Arena ${date.toLocaleString()}`,
			cards: cards ? cards : ''
		};
		this.currentDeckName = deck.name;
		this.currentDeckNameEdit = deck.name;
		this.$nextTick(() => {
			this.NextArenaOption();
		});
	},
	CreateRandomDeck()
	{
		var random = require('random');
		this.deck = [];
		for(var i = 0; i < this.randomizerSets.length; i++)
		{
			let set = this.randomizerSets[i];
			let possibleCards = [];
			for(let j = 0; j < set.rules.length; j++)
			{
				let filter = this.$refs[`filter-${i}-${j}`][0];
				filter.Search();
				possibleCards = possibleCards.concat(filter.filteredCards);
			}

			let seen = new Set();
			possibleCards = possibleCards.filter(item => {
								return seen.has(item.code) ? false : seen.add(item.code);
							});
			console.log(possibleCards);

			for(var j = 0; j < set.quantity; j++)
			{
				var rnd = random.int(0, possibleCards.length-1);
				var card = possibleCards[rnd];
				if(this.deck.length < 50)
					this.AddCard(card);
			}
		}
	},
	LoadCode(code) {
		this.deck = [];
		var cards = (code ? code : this.code).split(/,/g);
		cards.forEach(card => {
			if(this.dictCards[card]) this.AddCard(this.dictCards[card]);
		});
	},
	CopyCode() {
		var clipboard = require('clipboard-copy');
		clipboard(this.code);
	},
	Preview(val)
	{
		this.preview = val;
	},
	CopyRandomRules()
	{
		let ret = '';
		this.randomizerSets.forEach(set => {
			let strSet = set.quantity + '*';
			let strRules = '';
			set.rules.forEach(rules => strRules += '|'+rules);
			strRules = strRules.substring(1);
			ret += '&' + strSet + strRules;
		});
		ret = ret.substring(1);
		console.log(ret);

		var clipboard = require('clipboard-copy');
		clipboard(ret);
		alert('Copiado al portapapeles!');
	},
	LoadRandomRules()
	{
		let code = prompt('Ingresar codigo');
		let randomizerSets = [];
		if(code)
		{
			let sets = code.split(/\&/g);
			sets.forEach(set => {
				if(set.indexOf('*') > -1)
				{
					let setParts = set.split('*');
					let quantity = setParts[0];
					let rulesSets = setParts[1];
					randomizerSets.push({
						quantity: parseInt(quantity),
						rules: rulesSets.split(/\|/g)
					});
				}
			});
			
		}
		this.randomizerSets = randomizerSets;
	},
	NextArenaOption()
	{
		var random = require('random');
		let options = [];

		for(let i = 0; i < this.arenaSets.length; i++)
		{

			let set = this.arenaSets[i];
			let possibleCards = [];
			for(let j = 0; j < set.length; j++)
			{
				let filter = this.$refs[`arena-filter-${i}-${j}`][0];
				filter.Search();
				possibleCards = possibleCards.concat(filter.filteredCards);
			}

			let seen = new Set();
			possibleCards = possibleCards.filter(item => {
								return seen.has(item.code) ? false : seen.add(item.code);
							});

			var rnd = random.int(0, possibleCards.length-1);
			options.push(possibleCards[rnd]);

		}

		this.arenaOptions = options;
		console.log(options);
	},
	CopyArenaRules()
	{
		let ret = '';
		this.arenaSets.forEach(set => {
			let strRules = '';
			set.forEach(rules => strRules += '|'+rules);
			strRules = strRules.substring(1);
			ret += '&' + strRules;
		});
		ret = ret.substring(1);
		console.log(ret);

		var clipboard = require('clipboard-copy');
		clipboard(ret);
		alert('Copiado al portapapeles!');
	},
	LoadArenaRules()
	{
		let code = prompt('Ingresar codigo');
		let ret = [];
		if(code)
		{
			let sets = code.split(/\&/g);
			sets.forEach(set => {
				ret.push(set.split(/\|/g));	
			});
		}
		this.arenaSets = ret;
	},
  },
  computed: {
    orderedCards() {
      switch(this.orderBy)
      {
        case 'alfabetico':
          this.filteredCards.sort((a, b) => {
            var A = a.nombre.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('¡', '').replace('¿', '');
            var B = b.nombre.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('¡', '').replace('¿', '');
            if(A < B) return -1;
            if(B < A) return 1;
            return 0;
          });
		  break;
		case 'coste':
			this.filteredCards.sort((a, b) => {
				var A = a.tipo == 'Oro' ? -1 : a.coste;
				var B = b.tipo == 'Oro' ? -1 : b.coste;
				return B - A;
			});
			break;
		case 'edicion':
			var ediciones = {
				'Espada Sagrada': 1,
				'Cruzadas': 2,
				'Helénica': 3,
				'Imperio': 4,
				'Hijos de Daana': 5,
				'Tierras Altas': 6,
				'Dominios de Ra': 7,
				'Encrucijada': 8
			};
			this.filteredCards.sort((a, b) => {
				var A = ediciones[a.expansion] ? ediciones[a.expansion] : 10;
				var B = ediciones[b.expansion] ? ediciones[b.expansion] : 10;
				if(A == B) return a.numero - b.numero;
				return A - B;
			});
			
			break;
		case 'tipo':
			var tipos = {
				'Aliado': 1,
				'Talismán': 2,
				'Arma': 3,
				'Tótem': 4,
				'Oro': 5,
			};
			this.filteredCards.sort((a, b) => {
				var A = tipos[a.tipo];
				var B = tipos[b.tipo];
				return A - B;
			});
			
			break;
		case 'frecuencia': 
			var tipos = {
				'Vasallo': 1,
				'Cortesano': 2,
				'Real': 3,
			};
			this.filteredCards.sort((a, b) => {
				var A = tipos[a.frecuencia] ? tipos[a.frecuencia] : 0;
				var B = tipos[b.frecuencia] ? tipos[b.frecuencia] : 0;
				return B - A;
			});
			break;
		case 'fuerza': 
			this.filteredCards.sort((a, b) => {
				var A = a.tipo == 'Aliado' ? a.fuerza : -1;
				var B = b.tipo == 'Aliado' ? b.fuerza : -1;
				return B - A;
			});
			break;
		case 'raza': 
			var tipos = {
				'Caballero': 1,
				'Dragón': 2,
				'Faerie': 3,
				'Olímpico': 4,
				'Héroe': 5,
				'Titán': 6,
				'Desafiante': 7,
				'Sombra': 8,
				'Defensor': 9,
				'Eterno': 10,
				'Faraón': 11,
				'Sacerdote': 12
			};
			this.filteredCards.sort((a, b) => {
				var A = tipos[a.raza] ? tipos[a.raza] : 20;
				var B = tipos[b.raza] ? tipos[b.raza] : 20;
				return A - B;
			});
			break;
      }
      return this.filteredCards;
	},
	deckCode() {
		var ret = '';
		if(!this.deck.length) return '';
		this.deck.forEach(card => {
			ret += ',' + card.code;
		});
		return ret ? ret.substring(1) : ret;
	},
	deckStats() {
		var ret = {
			'Aliado': 0,
			'Arma': 0,
			'Talismán': 0,
			'Tótem': 0,
			'Oro': 0,
			coste1: 0,
			coste2: 0,
			coste3: 0,
			coste4: 0,
			coste5: 0,
			fuerza1: 0,
			fuerza2: 0,
			fuerza3: 0,
			fuerza4: 0,
			fuerza5: 0,
			'Espada Sagrada': 0,
			'Cruzadas': 0,
			'Helénica': 0,
			'Imperio': 0,
			'Hijos de Daana': 0,
			'Tierras Altas': 0,
			'Dominios de Ra': 0,
			'Encrucijada': 0,
			'Vasallo': 0,
			'Cortesano': 0,
			'Real': 0,
			'Caballero': 0,
			'Dragón': 0,
			'Faerie': 0,
			'Olímpico': 0,
			'Héroe': 0,
			'Titán': 0,
			'Desafiante': 0,
			'Sombra': 0,
			'Defensor': 0,
			'Eterno': 0,
			'Faraón': 0,
			'Sacerdote': 0
		}
		this.deck.forEach(card => {

			ret[card.tipo]++;
			if(card.tipo != 'Oro')
			{
				if(card.coste <= 1) ret.coste1++;
				else if(card.coste == 2) ret.coste2++;
				else if(card.coste == 3) ret.coste3++;
				else if(card.coste == 4) ret.coste4++;
				else if(card.coste >= 5) ret.coste5++;
			}

			if(card.tipo == 'Aliado')
			{
				if(card.fuerza <= 1) ret.fuerza1++;
				else if(card.fuerza == 2) ret.fuerza2++;
				else if(card.fuerza == 3) ret.fuerza3++;
				else if(card.fuerza == 4) ret.fuerza4++;
				else if(card.fuerza >= 5) ret.fuerza5++;
			}

		});
		return {
			types: [ret['Aliado'], ret['Talismán'], ret['Arma'], ret['Tótem'], ret['Oro']],
			cost: [ret.coste1, ret.coste2, ret.coste3, ret.coste4, ret.coste5],
			attack: [ret.fuerza1, ret.fuerza2, ret.fuerza3, ret.fuerza4, ret.fuerza5],
		};
	}
  },
  watch: {
	  deckCode: function(n, o) {
		  this.code = n;
	  }
  },
  components: {
    Card, CardsFilter
  },
  sockets: {
	disconnect() {
		console.log('disconected');
		alert('Error');
	},
	JoinedGame(data) {
		console.log(data);
		if(data.p1_deck) data.p1_deck = data.p1_deck.split(/,/g);
		if(data.p2_deck) data.p2_deck = data.p2_deck.split(/,/g);
		this.$emit('JoinGame', data);
	}
  }
}
</script>

<style>

body, html, #app {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

div {
  box-sizing: border-box;
}

input, select {
  padding: 10px;
  margin-bottom: 5px;
  background-color: ghostwhite;
  border: 1px solid rgba(0,0,0, 0.1);
  border-radius: 5px;
}

.content {
  display: flex; 
  flex: 1 1 auto; 
  /*flex-wrap: wrap; */
  flex-direction: row;
  padding: 10px; 
  overflow-y: auto;
  flex-wrap: wrap;
  gap: 4px;
  align-content: baseline;
}

.search-menu {
  display: flex; 
  flex-direction: column; 
  padding: 5px 10px; 
  background-color: white;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
  transition: top 0.2s;
  height: 100%;
}
.search-menu * {
	flex-shrink: 0;
}
.search-menu b {
	font-size: 10px;
	text-transform: uppercase;
	margin: 7px 0px;
}
.card-list.mini {
	margin-bottom: 1px;
	padding: 4px;
}
.card-list.mini .card-icon {
	
}
.card-list.mini .card-icon span{
	font-size: 15px;
	font-weight: bolder;
}
.card-list.mini b {
	text-transform: none;
	line-height: 0px;
}
.card-list.mini .card-race {
	text-transform: uppercase;
	font-size: 7px;
	line-height: 8px;
}
.code {
	padding: 5px;
    background-color: whitesmoke;
    color: #666;
    overflow-wrap: break-word;
    font-size: 10px;
    border-radius: 3px;
    margin-bottom: 5px;
	border: none;
}
.btn-round {
	border: none;
	background-color: white;
	height: 30px;
	border-radius: 20px;
	box-shadow: 0px 0px 5px 0px rgba(0,0,0, 0.1);
	margin: 4px 0px;
	font-size: 8px;
	text-transform: uppercase;
}
.btn-round:hover {
	background-color: #e0fcff;
	cursor: pointer;
}
.grid {
	flex-direction: row;
	flex-wrap: wrap;
}
.card-selection {
	cursor: pointer;
	transition: transform 0.05s linear;
	border-radius: 0.3vw;
}
.card-selection:hover {
	transform: scale(1.2);
	box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.5);
}
.header {
	position: absolute; 
	left: 0; 
	top: 0; 
	width: 100%; 
	padding: 10px; 
	display: flex; 
	background: black; 
	color: white; 
	align-items: center;
}
</style>
